export enum CurrentlyWorking {
  YES = 'YES',
  PARENTAL_LEAVE = 'PARENTAL_LEAVE',
  NO = 'NO',
  STUDENT_OR_HOMEMAKER = 'STUDENT_OR_HOMEMAKER',
}
